// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e01a9193","732":"2bcda309","977":"9ef769b7"}[chunkId] + ".chunk.js";
};